(() => {
  const mediaQuery = window.matchMedia('(max-width: 989px)');

  const getMount = (source) => {
    const sectionId = source.dataset.sectionId;
    const context = mediaQuery.matches ? 'mobile' : 'desktop';

    if (!sectionId) return null;

    return document.querySelector(
      `[data-brand-logo-menu-mount][data-section-id="${CSS.escape(sectionId)}"][data-context="${context}"]`
    );
  };

  const mountMenu = (source) => {
    const mount = getMount(source);

    if (!mount) {
      source.hidden = true;
      return;
    }

    if (source.parentElement !== mount) {
      mount.appendChild(source);
    }

    source.hidden = false;
  };

  const initialiseMenus = (root = document) => {
    root.querySelectorAll('[data-brand-logo-menu-source]').forEach((source) => {
      if (source.dataset.brandLogoMenuInitialised === 'true') {
        mountMenu(source);
        return;
      }

      source.dataset.brandLogoMenuInitialised = 'true';
      source._brandLogoMenuMount = () => mountMenu(source);
      mediaQuery.addEventListener('change', source._brandLogoMenuMount);
      mountMenu(source);
    });
  };

  const destroyMenus = (root) => {
    root.querySelectorAll('[data-brand-logo-menu-source]').forEach((source) => {
      if (source._brandLogoMenuMount) {
        mediaQuery.removeEventListener('change', source._brandLogoMenuMount);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseMenus());
  } else {
    initialiseMenus();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseMenus(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyMenus(event.target));
  document.addEventListener('shopify:block:select', () => initialiseMenus());
})();